import { apiClient } from './client';
import { ENDPOINTS } from '../constants/api';

export const housesAPI = {
  getMyHouses: async () => {
    const response = await apiClient.get(ENDPOINTS.HOUSES.LIST);
    return response.data.houses || response.data;
  },

  createHouse: async (data) => {
    const response = await apiClient.post(ENDPOINTS.HOUSES.CREATE, data);
    return response.data;
  },

  joinHouse: async (data) => {
    const response = await apiClient.post(ENDPOINTS.HOUSES.JOIN, data);
    return response.data;
  },

  getHouseDetail: async (houseId) => {
    const response = await apiClient.get(ENDPOINTS.HOUSES.DETAIL(houseId));
    return response.data;
  },

  getHouseMembers: async (houseId) => {
    const response = await apiClient.get(ENDPOINTS.HOUSES.MEMBERS(houseId));
    return response.data.members || response.data;
  },

  updateHouse: async (houseId, data) => {
    const response = await apiClient.put(ENDPOINTS.HOUSES.UPDATE(houseId), data);
    return response.data;
  },

  deleteHouse: async (houseId) => {
    await apiClient.delete(ENDPOINTS.HOUSES.DELETE(houseId));
  },
};
